import {ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal} from '@angular/core';
import {CommonModule} from '@angular/common';

import {DrawingModel, EventModel, GameModel, GroupRankingModel} from 'shared/models';
import {GroupUi} from '../group-ui/group-ui';

@Component({
  selector: 'groups-ui',
  standalone: true,
  imports: [CommonModule, GroupUi],
  templateUrl: './groups-ui.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupsUi {
  event: InputSignal<EventModel> = input.required<EventModel>();
  drawings: InputSignal<DrawingModel[]> = input.required<DrawingModel[]>();
  games: InputSignal<GameModel[]> = input.required<GameModel[]>();
  groupsRankings: InputSignal<GroupRankingModel[]> = input.required<GroupRankingModel[]>();

  protected groups: Signal<number[]> = computed((): number[] => {
    const drawings: DrawingModel[] = this.drawings();
    const groups: number[] = drawings.map((model: DrawingModel): number => {
      return model.group;
    });
    // Unique
    return [...new Set(groups)];
  });
}
